import { render, staticRenderFns } from "./IconOutgoingReferrals.vue?vue&type=template&id=48fc1aaa&"
import script from "./IconOutgoingReferrals.vue?vue&type=script&lang=ts&"
export * from "./IconOutgoingReferrals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports